export enum EInfoHeaderStyle {
  Regular,
  Warning,
}
